//store/modules/treasurers.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

const state = {}

const getters = {}

const actions = {
  async getPoster({ commit }, myFund) {
    let response = await axios.post('/poster', myFund)
    await commit('setResponse', response)
    return response
  },
  async addDocument({ commit }, doc) {
    let response = await axios.post('/service/fundraiser/addImage', {
      campaign_id: doc.campaign_id,
      data: doc,
      tableName: 'survey_files',
    })
    await commit('setResponse', response.data)
    return response.data
  },
  async deleteDocument({ commit }, doc) {
    let response = await axios.post('/service/fundraiser/retire_detailsP', doc)
    await commit('setResponse', response.data)
    return response.data
  },
  async getDocData({ commit }, doc) {
    let response = await axios.post('/service/fundraiser/fetch_dataS', doc)
    await commit('setResponse', response.data)
    return response.data
  },
}

const mutations = {
  setResponse(state, response) {
    state.resp = response
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
